// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1Ssh3","footer":"ModalCreateQualiphyProcedure_footer__2hROU","additionData":"ModalCreateQualiphyProcedure_additionData__3_Skz"};